import { __assign } from "tslib";
// DS: C25A
import React, { useContext } from 'react';
import FolderDropdownDesktop from './FolderDropdownDesktop';
import FolderDropdownMobileV3 from './FolderDropdownMobileV3';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
var FolderDropdown = function (props) {
    var isMobile = useContext(MobileContext);
    if (isMobile) {
        return React.createElement(FolderDropdownMobileV3, __assign({}, props));
    }
    return React.createElement(FolderDropdownDesktop, __assign({}, props));
};
export default FolderDropdown;
//# sourceMappingURL=FolderDropdown.js.map